import { render } from "./systemAddRouter.vue?vue&type=template&id=a8b42342&scoped=true"
import script from "./systemAddRouter.vue?vue&type=script&lang=js"
export * from "./systemAddRouter.vue?vue&type=script&lang=js"

import "./systemAddRouter.vue?vue&type=style&index=0&id=a8b42342&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b42342"]])

export default __exports__